import o from"./_root.js";var r=o,t=function(){return r.Date.now()};export{t as default};
